/* @refresh reload */
import { MountableElement, render } from 'solid-js/web';
import './assets/index.less';
import App from './app';
type AppData = {
    artworkId: number;
    googleMapsApiKey: string;
};
const value = (document.getElementById("solid-app-data") as HTMLScriptElement)?.innerText;
const appData = JSON.parse(value) as AppData;
render(() => <App
    artworkId={appData.artworkId}
    googleMapsApiKey={appData.googleMapsApiKey} />,
    document.getElementById('root') as MountableElement);